import { CustomTypography } from '../../../CustomTypography';
import styles from '../Specialists.module.scss';
import cn from 'classnames';
import { formatedPrice } from '../../../../helpers/formatedPrice';

const PriceComponent = ({
  price,
  discountedPrice,
}: {
  price: number;
  discountedPrice: number;
}) => {
  return (
    <section className={styles.priceSection}>
      <CustomTypography className={styles.label}>Цена сессии</CustomTypography>
      <div className={styles.priceBlock}>
        <CustomTypography className={cn(styles.price, styles.priceStrike)}>
          {formatedPrice(price, false)}
        </CustomTypography>
        <CustomTypography className={styles.discountedPrice}>
          {formatedPrice(discountedPrice)}
        </CustomTypography>
      </div>
    </section>
  );
};

export default PriceComponent;
